import React from 'react';

import { i18n } from 'config/locales';

import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Subsection from 'components/Section/shared/Subsection';
import { FINANCIAL, FINANCIAL_CIVIL_JUDGEMENT } from 'config/formSections/financial';

import Branch from 'components/Form/Branch';
import Accordion from 'components/Form/Accordion';
import { DateSummary, Summary } from 'components/Summary';
import { DeepSafePartial } from 'types/types';
import { FinancialCivilJudgementModel } from 'forms/sections/financial/civilJudgement/types';
import CivilJudgementItem from './CivilJudgementItem';

const sectionConfig = {
  key: FINANCIAL_CIVIL_JUDGEMENT.key,
  section: FINANCIAL.name,
  store: FINANCIAL.store,
  subsection: FINANCIAL_CIVIL_JUDGEMENT.name,
  storeKey: FINANCIAL_CIVIL_JUDGEMENT.storeKey,
};

export class CivilJudgement extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
    this.summary = this.summary.bind(this);
  }

  summary = (item, index) => {
    const o = (item && item.Item) || {};
    const date = DateSummary(o.When);
    const courtName = (o.CourtName || {}).value || '';

    return Summary({
      type: i18n.t('financial.pvq.civilJudgement.summary.type'),
      index,
      left: courtName,
      right: date,
      placeholder: i18n.t('financial.pvq.civilJudgement.summary.unknown'),
    });
  };

  update = (queue: DeepSafePartial<FinancialCivilJudgementModel>) => {
    this.props.onUpdate(this.storeKey, {
      HasCivilJudgement: this.props.HasCivilJudgement,
      List: this.props.List,
      ...queue,
    });
  };

  updateList = (values:FinancialCivilJudgementModel['List']) => {
    this.update({
      List: values,
    });
  };

  updateHasCivilJudgment = (values:FinancialCivilJudgementModel['HasCivilJudgement']) => {
    this.update({
      HasCivilJudgement: values,
      List: values?.value === 'No' ? {} : this.props.List,
    });
  };

  render() {
    const {
      errors,
      required,
      scrollIntoView,
      scrollToBottom,
      defaultState,
      dispatch
    } = this.props;

    const accordionErrors = errors && errors.filter((e) => e?.indexOf?.('List.accordion') === 0);

    return (
      <div
        className="section-content civiljudgement"
        data-section={FINANCIAL.key}
        data-subsection={FINANCIAL_CIVIL_JUDGEMENT.key}
      >
        <h1 className="section-header">{i18n.t('financial.pvq.destination.civiljudgement')}</h1>
        <Branch
          name="has_civiljudgement"
          label={i18n.t('financial.pvq.civilJudgement.branch.title')}
          labelSize="h4"
          className="civiljudgement-branch"
          {...this.props.HasCivilJudgement}
          warning
          onUpdate={this.updateHasCivilJudgment}
          required={required}
          scrollIntoView={scrollIntoView}
          onError={this.handleError}
          attribute="CivilJudgement"
        />
        {this.props.HasCivilJudgement?.value === 'Yes' && (
          <Accordion
            {...this.props.List}
            defaultState={defaultState}
            scrollToBottom={scrollToBottom}
            onUpdate={this.updateList}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={required}
            summary={this.summary}
            errors={accordionErrors}
            scrollIntoView={scrollIntoView}
            appendTitle={i18n.t('financial.pvq.civilJudgement.appendTitle')}
            attribute="List"
          >
            <CivilJudgementItem
              name="Item"
              dispatch={dispatch}
              required={required}
              scrollIntoView={scrollIntoView}
              bind
              attribute="List"
            />
          </Accordion>
        )}
      </div>
    );
  }
}

CivilJudgement.defaultProps = {
  onUpdate: () => {},
  onError: (value, arr) => arr,
  dispatch: () => {},
  defaultState: true,
  scrollToBottom: '.bottom-btns',
  errors: [],
};

export default connectSubsection(CivilJudgement, sectionConfig);
